class ProgramTarget {
  init(params) {
    const d1 = new Date(params.value);
    this.params = params;
    this.eGui = document.createElement("div");
    this.eGui.className = "ag-header-group-cell-label";
    this.eGui.innerHTML =
      "" +
      '<div class="customHeaderLabel">' +
      d1.toLocaleString("default", { month: "short" }) +
      " " +
      d1.getDay() +
      ", " +
      d1.getFullYear() +
      "</div>";
  }
  getGui() {
    return this.eGui;
  }
}
export default ProgramTarget;
